import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { permissionMock } from 'fixture/';
import Modal from 'containers/Modal/Modal';
import { clearModal } from 'actions/modals/';
import { USER_MODAL } from 'constants/modal';
import { createUser, updateUser, getUserWarehouses } from 'actions/users/';
import UserForm from 'components/Users/UserForm/UserForm';

const UserModal = () => {
  const dispatch = useDispatch();

  const user = useSelector(({ user }) => user);
  const modal = useSelector(({ modal }) => modal);
  const warehouses = useSelector(({ warehouses }) => warehouses);
  const userWarehouses = useSelector(({ userWarehouses }) => userWarehouses);

  const isOpen = modal?.type === USER_MODAL;
  const isEditing = isOpen && modal.initialValue;
  const modalCaption = isEditing ? 'Update User' : 'Create A User';
  const { initialValue } = modal;
  const editedUserId = initialValue?.id;
  const hasLoadedAssignments =
    isEditing && userWarehouses.userId === editedUserId;
  const assignedWarehouseIds = hasLoadedAssignments ? userWarehouses.data : [];
  const isLoadingAssignments = Boolean(isEditing) && userWarehouses.isLoading;

  useEffect(() => {
    if (isOpen && editedUserId) {
      dispatch(getUserWarehouses(editedUserId));
    }
  }, [dispatch, isOpen, editedUserId]);

  const onModalClose = () => {
    dispatch(clearModal(USER_MODAL));
  };

  /**
    @param {FormData} payload
    @param {string[]} [warehouseIds] Set only when the warehouse selection was changed
   */
  const onSubmit = (payload, warehouseIds) => {
    const { company_id: companyId } = user;
    const { id: userId } = initialValue || {};

    payload.append('company_id', companyId);

    if (isEditing) {
      payload.append('id', userId);

      dispatch(updateUser(userId, payload, companyId, false, warehouseIds));
    } else {
      dispatch(createUser(payload, companyId, false, undefined, warehouseIds));
    }
  };

  return (
    <Modal isOpen={isOpen} onClose={onModalClose} caption={modalCaption}>
      <UserForm
        onSubmit={onSubmit}
        initialValue={initialValue}
        warehouses={warehouses.data}
        onModalClose={onModalClose}
        permissions={permissionMock}
        assignedWarehouseIds={assignedWarehouseIds}
        isLoadingWarehouses={isLoadingAssignments}
      />
    </Modal>
  );
};

export default UserModal;
